(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    const gallery = document.querySelector('[data-soma-gallery]');
    if (gallery) {
      const stage = gallery.querySelector('[data-soma-gallery-stage]');
      const caption = gallery.querySelector('[data-soma-gallery-caption]');
      const thumbs = gallery.querySelectorAll('[data-soma-thumb]');
      thumbs.forEach((btn) => {
        btn.addEventListener('click', () => {
          thumbs.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          if (caption) caption.textContent = btn.dataset.caption || '';
          stage.classList.toggle('soma-pdp__gallery-main--flush', btn.dataset.fit === 'cover');
          stage.textContent = '';
          if (btn.dataset.type === 'video') {
            const video = document.createElement('video');
            video.src = btn.dataset.src;
            video.autoplay = true;
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.controls = true;
            stage.appendChild(video);
          } else {
            const img = document.createElement('img');
            img.src = btn.dataset.src;
            img.alt = btn.dataset.alt || '';
            img.className = 'soma-pdp__img';
            stage.appendChild(img);
          }
        });
      });
    }

    const form = document.querySelector('[data-soma-product-form]');
    if (!form) return;
    const select = form.querySelector('[data-soma-variant-select]');
    const priceEl = document.querySelector('[data-soma-price]');
    const compareEl = document.querySelector('[data-soma-compare]');
    if (!select) return;

    const radios = form.querySelectorAll('input[type="radio"][name^="options"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', syncVariant);
    });

    function syncVariant() {
      const chosen = {};
      radios.forEach((r) => {
        if (r.checked) {
          const m = r.name.match(/options\[(.+)\]/);
          if (m) chosen[m[1]] = r.value;
        }
      });
      const options = Array.from(select.options);
      const match = options.find((o) => {
        return Object.values(chosen).every((v) => o.textContent.includes(v));
      });
      if (match) {
        select.value = match.value;
        if (priceEl && match.dataset.price) priceEl.textContent = match.dataset.price;
        if (compareEl) { compareEl.textContent = match.dataset.compare || ''; compareEl.hidden = !match.dataset.compare; }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
